module.exports = __webpack_public_path__ + "img/step11-c.d227675d.png";